export default {
  verticalSliderContainer: {
    flexDirection: "column",
    marginBottom: 20,
    maxHeight: "none",
    height: "auto",
  },
};
